import React from 'react';
import Button from '../button/index';
import DiscountsTwo from './discounts-two';
import MenuItem from './menu-item';
import cx from 'classnames';
var clsPrefix = 'tcpc-discounts';

var DiscountsItem = function DiscountsItem(props) {
  var onClick = props.onClick,
      style = props.style,
      className = props.className,
      packageValue = props.packageValue,
      discounts = props.discounts,
      countdown = props.countdown,
      region = props.region,
      title = props.title;
  var baseProps = {
    style: style,
    className: cx(clsPrefix, className)
  };
  return /*#__PURE__*/React.createElement("div", Object.assign({}, baseProps), /*#__PURE__*/React.createElement("i", {
    className: "".concat(clsPrefix, "-gift-icon")
  }), title || /*#__PURE__*/React.createElement("div", {
    className: "".concat(clsPrefix, "-header")
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(clsPrefix, "-gift")
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(clsPrefix, "-price")
  }, packageValue), "\u512A\u60E0\u79AE\u5305"), !!countdown && /*#__PURE__*/React.createElement("div", {
    className: "".concat(clsPrefix, "-day")
  }, countdown)), /*#__PURE__*/React.createElement("div", {
    className: "".concat(clsPrefix, "-content")
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(clsPrefix, "-item")
  }, Array.isArray(discounts) && discounts.map(function (item) {
    return /*#__PURE__*/React.createElement("div", {
      className: "".concat(clsPrefix, "-gift-content"),
      key: item.label
    }, /*#__PURE__*/React.createElement("div", {
      className: "".concat(clsPrefix, "-gift-label")
    }, item.label, "\uFF1A"), item.content);
  }), /*#__PURE__*/React.createElement("div", {
    className: "".concat(clsPrefix, "-region")
  }, region), /*#__PURE__*/React.createElement("div", {
    className: "".concat(clsPrefix, "-footer")
  }, /*#__PURE__*/React.createElement(Button, {
    className: "".concat(clsPrefix, "-gift-btn"),
    inline: true,
    radius: true,
    type: "warning",
    size: "large",
    onClick: onClick
  }, "\u9818\u53D6\u512A\u60E0")))));
};

DiscountsItem.DiscountsTwo = DiscountsTwo;
DiscountsItem.MenuItem = MenuItem;
export default DiscountsItem;